import AiAskBarComposerEditor from './AiAskBarComposerEditor'

export default function AiAskBarComposerEditorSlot({
  vm,
  actions,
  mentionMembers,
  mentionAgents,
}) {
  return (
    <AiAskBarComposerEditor
      composerEditorRef={vm.composerEditorRef}
      inputPlaceholder={vm.inputPlaceholder}
      isDictating={vm.isDictating}
      isExpanded={vm.isExpanded}
      textareaMaxHeightPx={vm.textareaMaxHeightPx}
      setComposerPlainText={vm.setComposerPlainText}
      handleComposerEnter={actions.handleComposerEnter}
      isEmailReply={vm.isEmailReply}
      mentionMembers={mentionMembers}
      mentionAgents={mentionAgents}
    />
  )
}
